/* eslint-disable no-unused-vars */
import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify/lib";
import BatteryOutline from "@/components/icons/battery-outline.vue";
import PV from "@/components/icons/pv.vue";
import Hydro from "@/components/icons/hydro.vue";
import Geothermal from "@/components/icons/geothermal.vue";
import Thermal from "@/components/icons/thermal.vue";
import Inverter from "@/components/icons/inverter.vue";
// import colors from 'vuetify/es5/util/colors';

const themeOrig = {
  primary: "#306d8a",
  secondary: "#16bbe5",
  accent: "#90d7ec",
  storage: "#5144D4",
  thermalGenerator: "#B46E0D",
  renewablePV: "#D5BE16",
  ev: "#90E274",
  renewableHydro: "#588D6D",
  demand: "#DA3490",
  emulated: "#E67A17",
  market: "#6339B0",
  renewableWind: "#2680eb",
  inverter: "#58339d",
};

const chartColorSet = {
  demand: "#DA3490",
  peakDemand: "#222A2A",
  vomCost: "#EB663B",
  emissionCost: "#1CA71C",
  fuelCost: "#2E91E5",
  generationCost: "#222A2A",
};

const fuelTypeColorSet = {
  URANIUM: "#E0FF66",
  COAL: "#222A2A",
  HYDRO: "#9189FA",
  WIND: "#2680EB",
  BIOMASS: "#1CA71C",
  HEAVY_FUEL: "#6C4516",
  HEAVY_FUEL_OIL: "#6C4516",
  DISTILLATE_FUEL_OIL: "#B2828D",
  SOLAR_PV: "#D5BE16",
  GEOTHERMAL: "#EB663B",
  HYDRO_ROR: "#9189FA",
  NATURAL_GAS: "#0D2A63",
  DIESEL: "#322C2B",
};

const themeAdj = {
  primary: "#16bbe5",
  secondary: "#2A53E9",
  accent: "#11EE4B",
};

const themeAdj2 = {
  primary: "#2A53E9",
  secondary: "#6227E9",
  accent: "#166bbe5",
};

const themeTri = {
  primary: "#16bbe5",
  secondary: "#FF2D12",
  accent: "#FFB712",
};

// TODO: Revise Light & Dark theme colors
// TODO: Review Acelerex Color Scheme/Pallette in general

Vue.use(Vuetify);
export default new Vuetify({
  icons: {
    iconfont: "mdi",
    values: {
      batteryOutline: {
        component: BatteryOutline,
      },
      inverter: {
        component: Inverter,
      },
      pv: {
        component: PV,
      },
      hydro: {
        component: Hydro,
      },
      geothermal: {
        component: Geothermal,
      },
      thermal: {
        component: Thermal,
      },
      wind: "mdi-wind-turbine",
      market: "mdi-finance",
      residential: "mdi-home-lightning-bolt",
      ev: "mdi-ev-station",
      demand: "mdi-home-city",
    },
  },
  theme: {
    themes: {
      light: { ...chartColorSet, ...fuelTypeColorSet, ...themeOrig },
      dark: { ...chartColorSet, ...fuelTypeColorSet, ...themeOrig },
    },
  },
});
